var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#73BE2F;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.71973,14c0-0.02734-0.01337-0.05029-0.0155-0.07703c-0.078-1.63538-0.74188-3.16589-1.90247-4.33606 c-1.23242-1.24268-2.94336-1.95508-4.69336-1.95508h-1.19385c-0.62579-2.64453-3.00049-4.62012-5.83398-4.62012H1.15332 c-0.55225,0-1,0.44775-1,1v13.41992c0,0.55273,0.44775,1,1,1h1.63379c-0.27844,0.52496-0.45117,1.11475-0.45117,1.75 c0,2.06738,1.67236,3.75,3.72852,3.75s3.72852-1.68262,3.72852-3.75c0-0.63525-0.17273-1.22504-0.45117-1.75h9.18951 c-0.2785,0.52496-0.45123,1.11475-0.45123,1.75c0,2.06738,1.67285,3.75,3.72852,3.75s3.72852-1.68262,3.72852-3.75 c0-0.63525-0.17273-1.22504-0.45123-1.75h1.63385c0.55273,0,1-0.44727,1-1v-3.18848c0-0.06586-0.00763-0.13049-0.00952-0.19604 C27.711,14.03058,27.71973,14.01672,27.71973,14z M24.38184,10.99512c0.56073,0.56549,0.93799,1.25781,1.14722,2.00488h-5.448 V9.63184h1.02734C22.3291,9.63184,23.52246,10.12891,24.38184,10.99512z M2.15332,5.01172h11.92725 c2.20227,0,3.99414,1.78931,3.99951,3.99036v7.42957H2.15332V5.01172z M7.79297,20.18164c0,0.96484-0.77539,1.75-1.72852,1.75 s-1.72852-0.78516-1.72852-1.75s0.77539-1.75,1.72852-1.75S7.79297,19.2168,7.79297,20.18164z M23.53711,20.18164 c0,0.96484-0.77539,1.75-1.72852,1.75s-1.72852-0.78516-1.72852-1.75s0.77539-1.75,1.72852-1.75S23.53711,19.2168,23.53711,20.18164 z M20.08105,16.43164V15h5.63867v1.43164H20.08105z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices5);
export default __webpack_public_path__ + "static/media/services5.0bec3ac6d7c8d5f595f74e946136cce3.svg";
export { ForwardRef as ReactComponent };